var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEnvIcn3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 74.051,
    height: 74.625,
    viewBox: "0 0 74.051 74.625",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "env-icn3",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2419",
    "data-name": "Groupe 2419",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_251",
    "data-name": "Rectangle 251",
    width: 74.051,
    height: 74.625,
    rx: 20,
    fill: "rgba(255,186,70,0.17)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2732",
    "data-name": "Groupe 2732",
    transform: "translate(-604.61 -10.861)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3015",
    "data-name": "Trac\\xE9 3015",
    d: "M649.2,48.629c-.4.355-.755.688-1.128,1a.733.733,0,0,0-.262.838c.316,1.332.57,2.678.878,4.011a.6.6,0,0,1-.208.66c-.408.381-.75,1.011-1.209,1.106-.437.091-.99-.363-1.489-.584A14.144,14.144,0,1,0,654.057,71a13.949,13.949,0,0,0-1.5-9.085c-.146-.272-.152-.45.1-.646a2.464,2.464,0,0,0,.5-.5,1.428,1.428,0,0,1,1.786-.542c1.137.319,2.308.514,3.46.779a.637.637,0,0,0,.711-.219c.327-.384.679-.746,1.046-1.143A21.989,21.989,0,1,1,649.2,48.629Z",
    transform: "translate(0 -18.975)",
    fill: "#ffaa1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3016",
    "data-name": "Trac\\xE9 3016",
    d: "M711.136,123.947c-1.364,1.371-2.7,2.718-4.044,4.047a.677.677,0,0,1-.495.123,6.274,6.274,0,1,0,5.535,5.566.655.655,0,0,1,.094-.463c1.344-1.377,2.7-2.739,4.073-4.116a11.69,11.69,0,1,1-5.163-5.157Z",
    transform: "translate(-65.772 -84.711)",
    fill: "#ffaa1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3017",
    "data-name": "Trac\\xE9 3017",
    d: "M756.172,45.743c.473.114.942.245,1.42.333a.669.669,0,0,0,.513-.086q4.6-4.553,9.162-9.139a.676.676,0,0,0,.12-.53c-.279-1.391-.595-2.775-.868-4.167a.781.781,0,0,1,.174-.606q3.281-3.322,6.6-6.6a.814.814,0,0,1,.645-.241.839.839,0,0,1,.4.564c.362,1.581.7,3.167,1.027,4.755a.516.516,0,0,0,.475.478c1.556.316,3.108.649,4.653,1.011a1.044,1.044,0,0,1,.685.464c.065.166-.166.515-.349.7-2.129,2.153-4.279,4.285-6.41,6.436a.781.781,0,0,1-.845.237c-1.332-.311-2.676-.57-4.01-.874a.62.62,0,0,0-.667.184q-4.48,4.491-8.983,8.96a.6.6,0,0,0-.139.743,3.827,3.827,0,1,1-7.43,1.219A3.929,3.929,0,0,1,756.172,45.743Z",
    transform: "translate(-116.051)",
    fill: "#ffaa1c"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvIcn3);
export default __webpack_public_path__ + "static/media/env-icn3.91ccfa7739c5eeb5f3e10d14cd4cdcce.svg";
export { ForwardRef as ReactComponent };